import * as React from 'react'
// import ReactRouterDOM from 'react'
import {AFrameScene} from '../../../library/aframe-components'
import {loadingScreenComponent} from '../../../library/custom/loading-screen-coloane'
import {backButtonComponent} from '../../../library/custom/back-button'
import {targetImageControlComponent} from '../../../library/custom/target-image-control'
import {colourfulRoostersComponent} from '../../../pages/coloane-macau/colourful-roosters/module/colourful-roosters-component'
import {html} from './UI/colourful-roosters-scene'

const ARComponents = [
  {name: 'loading-screen', val: loadingScreenComponent},
  {name: 'back-btn-control', val: backButtonComponent},
  {name: 'target-image-control', val: targetImageControlComponent},
  {name: 'colourful-roosters', val: colourfulRoostersComponent}
]

export const ColourfulRoosters = () => {

  const webTitle = '葡國公雞 | 悠路環 AR'
  document.title = webTitle
  window.gtag('config', process.env.REACT_APP_GTAG, {
    page_title: webTitle,
    page_location: 'https://barra-studio-ar.netlify.app/coloane-macau/colourful-roosters-scene', // The full URL is required.
  })
  return(
    <React.Fragment>
      <AFrameScene
        sceneHtml={html}
        
        components={ARComponents}
      />
    </React.Fragment>
  )
}


export default ColourfulRoosters
